CustomRenderMixin = require 'components/mixins/custom_render_mixin'
ConnectStores = require 'components/enhancers/connect_store'
EtdActions = require 'actions/etd_actions'
EtdStore = require 'stores/etd_store'
QuestionGroupsStore = require 'stores/question_groups_store'
QuestionsStore = require 'stores/questions_store'
RelatedRecommendationsModal = require 'components/etd/related_recommendations_modal'
Translation = require 'components/mixins/translation'
{ instanceOf, string, bool } = PropTypes

storeConnectors =
  EtdStore: (Store) ->
    relatedEvidenceIds: Store.getRelatedEvidenceIds()
    hiddenRelatedEvidence: Store.getHiddenRelatedEvidence()
  QuestionsStore: (Store) ->
    questions: Store.getQuestions()
  QuestionGroupsStore: (Store) ->
    questionGroups: Store.getQuestionGroups()

RelatedEvidences = createReactClass

  displayName: "RelatedEvidences"
  mixins: [
    CustomRenderMixin,
    Translation('')
  ]

  propTypes:
    relatedEvidenceIds: instanceOf(Immutable.List).isRequired
    questions: instanceOf(Immutable.Map).isRequired
    questionGroups: instanceOf(Immutable.Map).isRequired
    editable: bool

  getInitialState: ->
    showRRModal: false

  updateRelatedEvidenceIds: (relatedEvidenceIds) ->
    EtdActions.updateRelatedEvidenceIds relatedEvidenceIds
    @setState showRRModal: false

  openRRModal: ->
    @setState showRRModal: true

  closeRRModal: ->
    @setState showRRModal: false

  render: ->
    {
      editable
      questions
      questionGroups
      relatedEvidenceIds
    } = @props

    buttonLabel = if relatedEvidenceIds.isEmpty()
      'actions.add_related_evidence'
    else
      'actions.edit_related_evidence'

    <div className="related-recommendations">
      <div className="flex items-center gap-10">
        <button className="btn btn-add" onClick={@openRRModal} disabled={not editable}>
          {@i18n buttonLabel}
        </button>
        {@state.showRRModal and
          <RelatedRecommendationsModal
            questions={questions}
            questionGroups={questionGroups}
            relatedQuestionsIds={relatedEvidenceIds}
            updateRelatedQuestionsIds={@updateRelatedEvidenceIds}
            onClose={@closeRRModal}
          />
        }
      </div>
    </div>

module.exports = ConnectStores RelatedEvidences,
  [EtdStore, QuestionsStore, QuestionGroupsStore], storeConnectors
